// src/Components/HighLevelComponents/NavigationBar/SimplifiedNavigationBar.tsx
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { HiOutlineMenuAlt3, HiX } from "react-icons/hi";
import Logo from "../Logo/Logo";

interface SimplifiedNavigationBarProps {
  transparent?: boolean;
}

const SimplifiedNavigationBar: React.FC<SimplifiedNavigationBarProps> = ({
  transparent = false,
}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header
      className={`w-full z-40 ${
        transparent ? "absolute top-0 left-0" : "relative bg-white shadow-sm"
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <Logo size="60px" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/landing-tools"
              className="text-gray-600 hover:text-gray-900 font-medium transition-colors"
            >
              Tools
            </Link>
            <Link
              to="/signin"
              className="text-gray-600 hover:text-gray-900 font-medium transition-colors"
            >
              Sign In
            </Link>
            <Link
              to="/signup"
              className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900 py-2 px-5 rounded-lg font-medium transition-all duration-200 hover:shadow-md"
            >
              Sign Up
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              type="button"
              className="text-gray-500 hover:text-gray-700 focus:outline-none"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? (
                <HiX className="h-6 w-6" />
              ) : (
                <HiOutlineMenuAlt3 className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-sm">
          <div className="container mx-auto px-4 py-3 space-y-3">
            <Link
              to="/landing-tools"
              className="block py-2 text-gray-600 hover:text-gray-900 font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              Tools
            </Link>
            <Link
              to="/signin"
              className="block py-2 text-gray-600 hover:text-gray-900 font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              Sign In
            </Link>
            <Link
              to="/signup"
              className="block py-2 text-center bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900 rounded-lg font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              Sign Up
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default SimplifiedNavigationBar;
